import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ROLES_FEATURE_KEY,
  RoleState,
  RolesPartialState,
  rolesAdapter,
} from './roles.reducer';

// Lookup the 'Roles' feature state managed by NgRx
export const getRolesState = createFeatureSelector<
  RolesPartialState,
  RoleState
>(ROLES_FEATURE_KEY);

const { selectAll, selectEntities } = rolesAdapter.getSelectors();

export const getRolesLoaded = createSelector(
  getRolesState,
  (state: RoleState) => state.loaded
);

export const getRolesError = createSelector(
  getRolesState,
  (state: RoleState) => state.error
);

export const getAllRoles = createSelector(getRolesState, (state: RoleState) =>
  selectAll(state)
);

export const getRolesEntities = createSelector(
  getRolesState,
  (state: RoleState) => selectEntities(state)
);

export const getSelectedRoleId = createSelector(
  getRolesState,
  (state: RoleState) => state.selectedId
);

export const getSelectedRole = createSelector(
  getRolesEntities,
  getSelectedRoleId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
